var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.5V12.5C23.5 10.6435 22.7625 8.86301 21.4497 7.55025C20.137 6.2375 18.3565 5.5 16.5 5.5C14.6435 5.5 12.863 6.2375 11.5503 7.55025C10.2375 8.86301 9.5 10.6435 9.5 12.5V15.5C9.5 18.8 6.5 19.6 6.5 21.5C6.5 23.2 10.4 24.5 16.5 24.5C22.6 24.5 26.5 23.2 26.5 21.5C26.5 19.6 23.5 18.8 23.5 15.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26.5C15.489 26.5 14.539 26.466 13.645 26.4C13.8356 27.008 14.2153 27.5393 14.7288 27.9164C15.2423 28.2936 15.8628 28.497 16.5 28.497C17.1371 28.497 17.7577 28.2936 18.2712 27.9164C18.7847 27.5393 19.1644 27.008 19.355 26.4C18.461 26.466 17.511 26.5 16.5 26.5Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/ALERT.f6ab6d0a7b547e2a2a32a34c6e11f5db.svg";
export { ForwardRef as ReactComponent };